import { apiCall } from '../../context/api';

export const createUser = async (formData, setToken, baseURL) => {
  try {
    const data = await apiCall(baseURL, null, 'POST', '/core/onboarding/create-user', formData);
    setToken(data.token);
    return true;
  } catch (error) {
    return false;
  }
};
